import { URLS } from "./data";
export const scrollToSection = (id) => {
    const e = document.getElementById(id);
    if (e)
        e.scrollIntoView({ behavior: "smooth" });
};
export const productsByCategory = (products, title) => {
    return title !== "NUESTROS PRODUCTOS"
        ? products.filter((item) => item.category === title)
        : products;
};
export const getProductPrice = (item) => {
    const numericPrice = Number(typeof item.price === "string" ? item.price.replace(/\./g, "") : item.price);
    const total = numericPrice * Number(item.quantity || 1);
    return formatPrice(total);
};
export const formatPrice = (price) => {
    return new Intl.NumberFormat("es-CO").format(price);
};
export const getBlogSubItems = (blog) => {
    return blog.entries.map((entry) => ({
        id: entry.id,
        title: entry.title,
        url: `${URLS.blog}/${entry.slug}`,
    }));
};
